import React, { useEffect, useState } from "react";
import {
  FaCheckCircle,
  FaClock,
  FaPauseCircle,
  FaSpinner,
} from "react-icons/fa";
import DashboardCard from "../../Components/Comman/DashbordCard";
import { GoProjectRoadmap } from "react-icons/go";
import {
  FcLowPriority,
  FcMediumPriority,
  FcHighPriority,
} from "react-icons/fc";
import { ProjectService } from "../../services/ProjectService";
import { toast } from "react-toastify";
import ToDoList from "../../Components/Comman/TodoList";
import MeetingList from "../../Components/Comman/MeetingList";
import { MeetingService } from "../../services/MeetingService";
const Dash = () => {
  const [statistics, setStatistics] = useState(null);
  const [meetingCount, setMeetingCount] = useState(null);

  useEffect(() => {
    const fectchStatistics = async () => {
      try {
        const response = await ProjectService.getStatisticsForCoordinator();
        if (response) {
          setStatistics(response);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };
    fectchStatistics();
  }, []);

  useEffect(() => {
    const fectchMeetingsCount = async () => {
      try {
        const response = await MeetingService.getTodaysMeetingCount();
        if (response) {
          setMeetingCount(response);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };
    fectchMeetingsCount();
  }, []);

  return (
    <section className="py-4 px-4 ">
      <div className="flex flex-col md:flex-row gap-6 ">
        {/* Cards */}
        <div className="w-full lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          <DashboardCard
            icon={GoProjectRoadmap}
            label="Total Projects"
            to="/emp-projects"
            count={statistics?.totalProjects}
            bgColor="bg-stone-100"
            borderColor="border-stone-200"
            textColor="text-stone-600"
          />
          <DashboardCard
            icon={FaClock}
            label="Pending Projects"
            to="/emp-projects"
            count={statistics?.pendingProjects}
            bgColor="bg-red-100"
            borderColor="border-red-200"
            textColor="text-red-600"
            status="pending"
          />
          <DashboardCard
            icon={FaPauseCircle}
            label="On Hold Projects"
            to="/emp-projects"
            count={statistics?.onHoldProjects}
            bgColor="bg-yellow-100"
            borderColor="border-yellow-200"
            textColor="text-yellow-600"
            status="on-hold"
          />
          <DashboardCard
            icon={FaSpinner}
            label="Active Projects"
            to="/emp-projects"
            count={statistics?.inProgressProjects}
            bgColor="bg-blue-100"
            borderColor="border-blue-100"
            textColor="text-blue-600"
            status="in-progress"
          />
          <DashboardCard
            icon={FaCheckCircle}
            label="Completed Projects"
            to="/emp-projects"
            count={statistics?.completedProjects}
            bgColor="bg-[#C8FFCD]"
            borderColor="border-green-200"
            textColor="text-green-600"
            status="completed"
          />
          <DashboardCard
            icon={FcLowPriority}
            label="Low Priority Projects"
            to="/emp-projects"
            count={statistics?.lowPriorityProjects}
            bgColor="bg-teal-100"
            textColor="text-teal-700"
            priority="low"
          />
          <DashboardCard
            icon={FcMediumPriority}
            label="Medium Priority Projects"
            to="/emp-projects"
            count={statistics?.mediumPriorityProjects}
            bgColor="bg-indigo-100"
            textColor="text-indigo-700"
            priority="medium"
          />
          <DashboardCard
            icon={FcHighPriority}
            label="High Priority Projects"
            to="/emp-projects"
            count={statistics?.highPriorityProjects}
            bgColor="bg-pink-100"
            textColor="text-pink-700"
            priority="high"
          />
          <DashboardCard
            icon={FaSpinner}
            label="Active Priority Projects"
            to="/emp-projects"
            count={statistics?.activePriorityProjects}
           bgColor="bg-cyan-100"
            textColor="text-cyan-700"
            priority="active"
          />
          <DashboardCard
            icon={FaPauseCircle}
            label="On-Hold Priority Projects"
            to="/emp-projects"
            count={statistics?.onHoldPriorityProjects}
            bgColor="bg-fuchsia-200"
            textColor="text-fuchsia-700"
            priority="on-hold"
          />
          
          <DashboardCard
            icon={GoProjectRoadmap}
            label="Today's Meetings"
            count={meetingCount?.todaysmeetingCount}
            bgColor="bg-amber-100"
            borderColor="border-amber-200"
            textColor="text-amber-600"
          />
        </div>

        <div className="w-full lg:w-[40%] flex flex-col gap-2">
          <ToDoList />
          <MeetingList />
        </div>
      </div>
    </section>
  );
};

export default Dash;
